function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { assign } from "d3plus-common";
import D3plusContext from "./D3plusContext.js";

/**
    @function Viz
    @desc Creates SVG paths and coordinate points based on an array of data. See [this example](https://d3plus.org/examples/d3plus-geomap/getting-started/) for help getting started using the geomap generator.
*/
var Viz = function Viz(props) {
  var className = props.className,
    config = props.config,
    dataFormat = props.dataFormat,
    linksFormat = props.linksFormat,
    nodesFormat = props.nodesFormat,
    topojsonFormat = props.topojsonFormat,
    Constructor = props.type;
  var forceUpdate = config.forceUpdate;
  var globalConfig = useContext(D3plusContext);
  var container = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    viz = _useState2[0],
    setViz = _useState2[1];

  /**
      @memberof Viz
      @desc Sets visualization config, accounting for dataFormat, linksFormat, nodesFormat or topojsonFormat, and renders the visualization.
      @private
  */
  var renderViz = function renderViz() {
    if (viz) {
      var c = assign({}, globalConfig, config);
      viz.config(c);
      if (dataFormat && c.data) viz.data(c.data, dataFormat);
      if (linksFormat && c.links) viz.links(c.links, linksFormat);
      if (nodesFormat && c.nodes) viz.nodes(c.nodes, nodesFormat);
      if (topojsonFormat && c.topojson) viz.topojson(c.topojson, topojsonFormat);
      viz.render();
    }
  };

  // first mount
  useEffect(function () {
    setViz(new Constructor().select(container.current));
  }, [container]);
  useEffect(renderViz, [viz]);
  if (forceUpdate) renderViz();else useEffect(renderViz, [JSON.stringify(globalConfig), JSON.stringify(config)]);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: container
  });
};
Viz.defaultProps = {
  className: "viz",
  forceUpdate: false
};
Viz.propTypes = {
  className: PropTypes.string,
  config: PropTypes.shape({
    forceUpdate: PropTypes.any
  }),
  dataFormat: PropTypes.func,
  linksFormat: PropTypes.func,
  nodesFormat: PropTypes.func,
  topojsonFormat: PropTypes.func,
  type: PropTypes.func
};

/**
    @memberof Viz
    @param {Object} [config = {}] An object containing method/value pairs to be passed to the visualization's .config( ) method.
    @param {Function} [dataFormat = d3plus.dataFold] A custom formatting function to be used when formatting data from an AJAX request. The function will be passed the raw data returned from the request, and is expected to return an array of values used for the data method.
    @param {Function} [linksFormat = d3plus.links(path, formatter)] A custom formatting function to be used when formatting links from an AJAX request. The function will be passed the raw data returned from the request, and is expected to return an array of values used for the links method.
    @param {Function} [nodesFormat = d3plus.nodes(path, formatter)] A custom formatting function to be used when formatting nodes from an AJAX request. The function will be passed the raw data returned from the request, and is expected to return an array of values used for the nodes method.
    @param {Function} [topojsonFormat = d3plus.topojson(path, formatter)] A custom formatting function to be used when formatting topojson from an AJAX request. The function will be passed the raw data returned from the request, and is expected to return an array of values used for the topojson method.
*/
export default Viz;